// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.side-legend[data-v-64a8b900] {\n  position: absolute;\n  right: 20px;\n  top: -30px;\n  background-color: var(--v-background-base);\n  height: 30px;\n  border: 2px;\n  border-color: var(--v-stark-base);\n  border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
